module.exports = __webpack_public_path__ + "static/img/contentB.e6f341b3.png";